module.exports = __webpack_public_path__ + "img/herat.b85a33fa.png";